import { api } from "../../api/api";
import { saveSupportContext } from "../supportContextStorage";
import {
  GET_USER_REQUEST,
  GET_USER_FAILED,
  GET_USER_SUCCESS,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  USER_SAVE_SUCCESS,
  LOGOUT,
  USER_FLAG_OFF,
  USER_SAVE_FAILED,
  USER_DELETE_SUCCESS,
  UPDATE_USER,
  LOGIN_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  REFRESH_LOGIN,
  EMAIL_TRANSFORED,
  EMAIL_TRANSFORED_FAILED,
  EMAIL_TRANSFOR_REQUEST,
  BLOCKED_USER,
  UNBLOCKED_USER
} from "../constant";
import toast from "react-hot-toast";
import { tr } from "../../i18n";

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch({
      type: LOGIN_REQUEST,
      payload: ''
    });
    try {
      const user = await api.post(`/user/login`, {
        email: email,
        password: password,
      });
      if (user.status === 201) {
        if (user.data.auth) {
          dispatch({ type: LOGIN_SUCCESS, payload: user.data });
        } else {
          dispatch({
            type: LOGIN_FAILED,
            payload: user.data,
          });
        }
      }
    } catch (err) {
      const message = err.code === 'ERR_NETWORK' || err.message === 'Network Error'
        ? 'Cannot reach server. Check that the backend is running (e.g. npm run server:dev) and the API URL is correct.'
        : (err.response?.data?.message || err.message);
      dispatch({
        type: LOGIN_FAILED,
        payload: { message },
      });
    }
  };
};


export const logout = () => {
  return async (dispatch) => {
    const user = await api.get('/user/logout');
    // window.localStorage.removeItem('leedoitLogin');
    saveSupportContext(null);
    dispatch({
      type: LOGOUT,
      payload: "",
    });
  };
};
let userRegisterInFlight = false;

export const userRegister = (obj) => {
  return async (dispatch) => {
    if (userRegisterInFlight) {
      return { ok: false, skipped: true };
    }
    userRegisterInFlight = true;
    try {
      const res = await api.post(`/user/register`, obj);
      const data = res.data || {};

      if (res.status === 201 && data.isRegistered) {
        const createdUser =
          data.user ||
          (data.userId
            ? {
                _id: data.userId,
                email: obj.email,
                username: obj.username,
                role: obj.role,
                organizationId: obj.organizationId,
                parentId: obj.organizationId || "",
              }
            : null);
        if (createdUser) {
          dispatch({
            type: USER_SAVE_SUCCESS,
            payload: createdUser,
          });
        }
        toast.success(tr("Account created successfully"));
        if (data.inviteEmailSent) {
          const to = data.inviteEmailTo || obj.email || "";
          toast.success(
            to
              ? `Invitation email sent to ${to} (check inbox & spam)`
              : "Invitation email sent"
          );
        } else if (data.inviteEmailError) {
          toast.error(`User created but email was not sent: ${data.inviteEmailError}`, {
            duration: 10000,
          });
        } else if (data.inviteEmailSent === false) {
          toast.error(tr("User created but invitation email was not sent. Check BREVO_API_KEY on the server."), {
            duration: 10000,
          });
        }
        return { ok: true };
      }

      const duplicate =
        res.status === 409 ||
        (res.status === 201 && data.isRegistered === false);
      const message = data.message || "Email already registered.";
      if (duplicate) {
        toast.error(message);
        return { ok: false, duplicate: true };
      }

      toast.error(message || "Could not create account");
      return { ok: false };
    } catch (err) {
      const status = err.response?.status;
      const message =
        err.response?.data?.message || err.message || "Could not create account";
      if (status === 409) {
        toast.error(message);
        return { ok: false, duplicate: true };
      }
      toast.error(message);
      return { ok: false };
    } finally {
      userRegisterInFlight = false;
    }
  };
};
export const userFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_FLAG_OFF,
      payload: "",
    });
  };
};
export const getUsers = (id, options = {}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_USER_REQUEST,
      payload: "",
    });
    
    const {
      page = 1,
      limit = 10,
      search,
      orgPage,
      orgLimit,
      usersPage,
      usersLimit,
    } = options;
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(orgPage && { orgPage: String(orgPage) }),
      ...(orgLimit && { orgLimit: String(orgLimit) }),
      ...(usersPage && { usersPage: String(usersPage) }),
      ...(usersLimit && { usersLimit: String(usersLimit) }),
    });
    
    try {
      const user = await api.get(`/user/getusers/${id}?${params}`);
      if (user.status === 200 && Array.isArray(user.data.users)) {
        dispatch({
          type: GET_USER_SUCCESS,
          payload: {
            users: user.data.users,
            pagination: user.data.pagination,
            sections: user.data.sections || null,
          },
        });
      } else {
        dispatch({
          type: GET_USER_FAILED,
          payload: "",
        });
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      toast.error(message || "Could not load users");
      dispatch({
        type: GET_USER_FAILED,
        payload: "",
      });
    }
  };
};
export const deleteUser = (id) => {
  return async (dispatch) => {
    const user = await api.get(`/user/deleteuser/${id}`);
    // console.log(user)
    if (user.status === 201) {
      dispatch({
        type: USER_DELETE_SUCCESS,
        payload: user.data.user._id
      })
    }
  }
}
export const deleteOrganization = (id) => {
  return async (dispatch) => {
    try {
      const response = await api.delete(`/user/deleteorganization/${id}`);
      if (response.status === 200) {
        dispatch({
          type: USER_DELETE_SUCCESS,
          payload: id,
        });
        return response.data;
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      toast.error(message || "Could not delete organization");
    }
    return null;
  };
};
export const updateUser = (id, obj) => {
  return async (dispatch) => {
    try {
      const updatedUser = await api.patch(`/user/updateuser/${id}`, obj);
      if (updatedUser.status === 201) {
        dispatch({
          type: UPDATE_USER,
          payload: updatedUser.data.updatedUser,
        });
        return updatedUser.data.updatedUser;
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      toast.error(message || "Could not update user");
    }
    return null;
  };
};
export const updateUserAssignedScreens = (id, assignedScreens) => {
  return async (dispatch) => {
    try {
      const response = await api.patch(`/user/assigned-screens/${id}`, {
        assignedScreens,
      });
      if (response.status === 200) {
        dispatch({
          type: UPDATE_USER,
          payload: response.data.updatedUser,
        });
        return response.data;
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      toast.error(message || "Could not update screen access");
    }
    return null;
  };
};
export const forgetPassword = (email) => {
  return async (dispatch) => {
    dispatch({
      type: EMAIL_TRANSFOR_REQUEST,
      payload: "",
    });
    try {
      const user = await api.post(`/user/forgetpassword`, { email });
      if (user.status === 201 && user.data.validUser) {
        dispatch({ type: EMAIL_TRANSFORED, payload: "" });
        return;
      }
      dispatch({ type: EMAIL_TRANSFORED_FAILED, payload: "" });
      if (user.status === 201 && !user.data.validUser) {
        return;
      }
      toast.error(
        user.data?.message ||
          "Could not send email. Check BREVO_API_KEY on the server."
      );
    } catch (err) {
      dispatch({ type: EMAIL_TRANSFORED_FAILED, payload: "" });
      const msg = err.response?.data?.message || err.message;
      toast.error(
        msg || "Could not send email. Check BREVO_API_KEY on the server."
      );
    }
  };
};
export const changePassword = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD_REQUEST,
      payload: ''
    })
    const response = await api.patch(`/user/changepassword/${obj.id}/${obj.token}`, { newpassword: obj.password })
    try {
      if (response.status === 201) {
        // if(response.data.timeup){
        //   dispatch({
        //     type:CHANGE_PASSWORD_FAILED,
        //     payload:''
        //   })
        // }
        if (response.data.timeup === false) {
          dispatch({
            type: CHANGE_PASSWORD_SUCCESS,
            payload: response.data.updatedPassword
          })
        }
      }
    } catch (error) {
      dispatch({
        type: CHANGE_PASSWORD_FAILED,
        payload: ''
      })
    }
  }
}
export const refreshLogin = (status, data) => {
  return async (dispatch) => {
    if (status === 201) {
      if (data.auth) {
        dispatch({ type: REFRESH_LOGIN, payload: data });
      }
    }
  }
}
export const statusOfUser = (id, _status) => {
  return async (dispatch) => {
    if (_status === 'block') {
      const { status, data } = await api.patch(`/user/blockuser/${id}`);
      if (status === 201) {
        dispatch({
          type: BLOCKED_USER,
          payload: data.statusUser
        })
      }
    }
    if (_status === 'unblock') {
      const { status, data } = await api.patch(`/user/unblockuser/${id}`);
      if (status === 201) {
        dispatch({
          type: UNBLOCKED_USER,
          payload: data.statusUser
        })
      }
    }
  }
}
